export default "__VITE_ASSET__CJatckMf__"